import { useEffect, useState } from 'react';
import { fetchUnitVersions } from '../services/unit.api';

export function useUnitVersions(unitName) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await fetchUnitVersions(unitName);
        if (mounted) setVersions(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
        if (mounted) setVersions([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [unitName]);

  return { loading, versions };
}
